import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgMoon = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.182 14.416A7.34 7.34 0 0 1 9.51 7.7a7.344 7.344 0 0 1 8.144-3.456c.04.01.047.064.012.086a6.64 6.64 0 0 0-2.88 7.337 6.63 6.63 0 0 0 6.167 4.909c.041.001.063.052.032.081a7.37 7.37 0 0 1-7.962 1.493"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7.08 16.495c-.957.009-1.73.652-1.73 1.746 0 .708.421 1.317 1.027 1.59.255.104.508.144.7.144h4.13c.193 0 .447-.038.705-.141a1.75 1.75 0 0 0 1.026-1.593c0-1.094-.773-1.737-1.73-1.746 0-.688-.54-2.065-2.064-2.065s-2.065 1.377-2.065 2.065"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M8.009 4.912v.007M4.72 8.28c.251.825.897 1.47 1.721 1.721-.824.251-1.47.896-1.72 1.72A2.59 2.59 0 0 0 3 10.002a2.59 2.59 0 0 0 1.72-1.72"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgMoon);
export default ForwardRef;
